import { SanityLink, Ticker, TickerSection } from "@bared/ui";
import clsx from "clsx";
import React from "react";
import tw from "twin.macro";
import {
  ServiceHighlightsOutputProps,
  withServiceHighlights,
} from "./withServiceHighlights";

const Image = tw.img`
  mr-micro
`;

export const ServiceHighlights = withServiceHighlights(
  ({ items, delay, openLiveChat }: ServiceHighlightsOutputProps) => (
    <Ticker delay={delay} className="mb-midi mt-mega">
      {items?.map(
        ({ _key, title, image, textLink, liveChat, imageReverse }) => {
          const link = textLink && textLink.length > 0 ? textLink[0] : null;

          return (
            <TickerSection id={`ticker-section-${title}`} key={_key}>
              {liveChat ? (
                <button
                  className={clsx(
                    imageReverse && "flex-row-reverse",
                    "flex flex-row items-center",
                  )}
                  onClick={() => openLiveChat()}
                  onKeyDown={() => openLiveChat()}
                >
                  {image ? (
                    <Image src={image.asset.url} alt={image.alt} />
                  ) : null}
                  <span className="text-hint underline">{title}</span>
                </button>
              ) : link ? (
                <SanityLink
                  className={clsx(
                    imageReverse && "flex-row-reverse",
                    "flex flex-row items-center",
                  )}
                  data={link}
                  target={link._type === "link" ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                >
                  {image ? (
                    <Image src={image.asset.url} alt={image.alt} />
                  ) : null}
                  <span className="text-hint underline">{title}</span>
                </SanityLink>
              ) : (
                <div
                  className={clsx(
                    imageReverse && "flex-row-reverse",
                    "flex flex-row items-center",
                  )}
                >
                  {image ? (
                    <Image src={image.asset.url} alt={image.alt} />
                  ) : null}
                  <span className="text-hint">{title}</span>
                </div>
              )}
            </TickerSection>
          );
        },
      )}
    </Ticker>
  ),
);
